import { COLOR_BACKGROUND_LIGHT, COLOR_GRAY } from '../../components/commander-ui/constants';

export const TICK_SIZE = 5;
export const X_AXIS_HEIGHT = 30;
export const DASH_LENGTH = 5;

export const DEFAULT_TICK_PROPS = {
    fill: COLOR_GRAY,
    fontSize: 11,
};
export const DEFAULT_AXIS_PROPS = {
    tickLine: false,
    axisLine: false,
    tickSize: TICK_SIZE,
};
export const DEFAULT_GRID_PROPS = {
    stroke: COLOR_BACKGROUND_LIGHT,
    vertical: false,
};
export const DEFAULT_LINE_PROPS = {
    strokeWidth: 2,
};
export const DEFAULT_TOOLTIP_PROPS = {
    isAnimationActive: false,
    separator: null,
    position: { y: 0 },
};
